<template>
  <el-col class="assembly_box ">
    <div class="assembly_title">疏散路线图
      <img src="@/assets/img/drillCenter/line.png" style="width: 78px;height: auto;" alt="">

    </div>
    <div class="exercise_chart">
      <el-image
        style="width: 100%; height: 100%;background:#fff;"
        :src="routeImg[0]"
        :preview-src-list="routeImg"
        title="点击查看疏散路线详情图"
      >
        <div
          slot="error"
          class="image-error"
          style="width: 100%; height: 100%;display:flex;justify-content: center;align-items: center;"
        >
          暂时没有路线疏散图
        </div>
      </el-image>
    </div>
  </el-col>
</template>
<script>
export default {
  name: "drillCenterRoute",
  components: {},
  props: {
    routeImg: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
  destroyed() {}
};
</script>
<style lang="scss" scoped>
.assembly_box {
  float: left;
  height: 100%;
  border: 2px solid #191919;
  padding-bottom: 2rem;
}

.emergency_team_right {
  display: inline-block;
  width: 55%;
  text-align: left;
}
.exercise_chart {
  width: 100%;
  height: 95%;
  margin-top: 10px;
  padding:0 2rem;
  // padding-bottom: 0;
}
</style>
